import { FC, PropsWithChildren, ReactElement } from 'react'

import './TableFoot.scss'

interface TableFootProps extends PropsWithChildren {
    className?: string;
}

const TableFoot: FC<TableFootProps> = ({
    className = '',
    children,
}): ReactElement => (
    <tfoot className={`table-foot ${className}`}>
        {children}
    </tfoot>
)

export default TableFoot
